import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8009';

export function MagicLinkVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [error, setError] = useState('');

  const verifyToken = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/auth/magic-link/verify/${token}`);

      if (response.data.success) {
        // Store tokens
        localStorage.setItem('device_token', response.data.token);
        localStorage.setItem('token', response.data.token);
        setStatus('success');

        // Redirect to app after brief delay
        setTimeout(() => {
          navigate('/', { replace: true });
          window.location.reload();
        }, 1500);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Magic link ongeldig of verlopen');
      setStatus('error');
    }
  }, [token, navigate]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-primary-50 to-primary-100">
      <div className="max-w-md w-full mx-4">
        <div className="card">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900">HavunCore</h1>
            <p className="text-gray-600 mt-2">Magic Link Login</p>
          </div>

          <div className="flex flex-col items-center space-y-6">
            {status === 'verifying' && (
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
                <p className="mt-4 text-gray-600">Link verwerken...</p>
              </div>
            )}

            {status === 'success' && (
              <div className="text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                  <span className="text-4xl">✅</span>
                </div>
                <p className="mt-4 text-lg font-medium text-green-600">Ingelogd!</p>
                <p className="mt-2 text-sm text-gray-500">Je wordt doorgestuurd...</p>
              </div>
            )}

            {status === 'error' && (
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto">
                  <span className="text-4xl">❌</span>
                </div>
                <p className="mt-4 text-lg font-medium text-red-600">{error}</p>
                <button
                  onClick={() => navigate('/', { replace: true })}
                  className="mt-6 btn-primary"
                >
                  Terug naar login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
